export function buildKey(key: string): string {
  return `fetch/bound-card-modal/${key}`
}
